import { store } from 'store';
import pConfig from 'pConfig';

const { token } = store.getState().user;

export default function setBooheeSeeConfig() {
  const config = Object.assign(window.$BooheeSeeConfig || {}, {
    url: pConfig.REPORT_URL,
    env: API_ENV === 'production' ? 'prod' : 'rc',
    appId: 'member',
    bizUserId: token,
    debug: false,
    sampleResoucreRate: 0.5,
    samplePerformanceRate: 0.5,
    apiIgnoreList: [
      {
        pattern: 'open-interface/v1/data/(report_data|report_distinct)',
        mode: 'regex'
      }
    ],
    resourceIgnoreList: [
      {
        pattern: /(member|house)\/.*?\.(png|jpg|woff2|otf|ttf|woff|jpeg)/i, // 忽略图片/字体资源
        mode: 'regex'
      },
      {
        pattern: /(bj\.boohee\.cn|one\.boohee\.cn|up\.boohee\.cn)/,
        mode: 'regex'
      }
    ],
    apiTransform: res => {
      if (res.code !== undefined) {
        return {
          code: res?.code?.toString(),
          message: res.message || 'unknown'
        };
      }

      if (res.errors) {
        return {
          code: res.errors?.[0]?.code?.toString() || 'unknown',
          message: res.errors?.[0]?.message || 'unknown'
        };
      }

      return {
        code: '0',
        message: res?.message || res?.msg || 'unknown'
      };
    }
  });

  window.$BooheeSeeConfig = config;
}
